(() => {
  const media = matchMedia('(max-width: 749px)');
  const original = new WeakMap();
  const observedRoots = new WeakSet();
  let queued = false;
  const schedule = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(update);
  };
  const observer = new MutationObserver(schedule);
  const resize = new ResizeObserver(schedule);
  const observedBars = new WeakSet();
  function update() {
    queued = false;
    const host = document.getElementById('moosedesk-widget-host');
    const shadow = host?.shadowRoot;
    if (!shadow) return;
    if (!observedRoots.has(shadow)) {
      observer.observe(shadow,{childList:true,subtree:true,attributes:true,attributeFilter:['style','class','hidden']});
      observedRoots.add(shadow);
    }
    const button = shadow.querySelector('button.mdw-float-btn');
    if (!button) return;
    if (!original.has(button)) original.set(button,{value:button.style.getPropertyValue('bottom'),priority:button.style.getPropertyPriority('bottom')});
    let clearance = 0;
    if (media.matches) {
      for (const bar of document.querySelectorAll('[data-ish-mobile-purchase],.ic-mobile-bar')) {
        if (!observedBars.has(bar)) {resize.observe(bar);observedBars.add(bar);}
        const rect = bar.getBoundingClientRect();
        const style = getComputedStyle(bar);
        if (!bar.hidden && rect.height > 0 && style.display !== 'none' && style.visibility !== 'hidden' && Number(style.opacity) !== 0 && rect.top < innerHeight && rect.bottom > 0) clearance = Math.max(clearance,innerHeight - rect.top + 16);
      }
    }
    const saved = original.get(button);
    const zoom = Number(getComputedStyle(button).zoom) || 1;
    const value = clearance ? Math.ceil(clearance / zoom) + 'px' : saved.value;
    const priority = clearance ? 'important' : saved.priority;
    if (button.style.getPropertyValue('bottom') !== value || button.style.getPropertyPriority('bottom') !== priority) {
      if (value) button.style.setProperty('bottom',value,priority);
      else button.style.removeProperty('bottom');
    }
  }
  observer.observe(document.body,{childList:true,subtree:true,attributes:true,attributeFilter:['class','style','hidden']});
  window.addEventListener('resize',schedule,{passive:true});
  window.addEventListener('scroll',schedule,{passive:true});
  media.addEventListener('change',schedule);
  document.addEventListener('shopify:section:load',schedule);
  schedule();
})();
